import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model["park_line"]): string | number =>
	item ?? "";

export default cellProcessing;
